/*
  One grade's population for one card: a link to that grade's certs, or nothing at all.

  Off Emotion (§7.4) and onto the shared LINK (D25). index.css's global
  `a { color: black }` rule is gone, so a link that declares no colour of its own stops
  looking like a link — every rebuilt link uses LINK rather than its own class.

  The count comes from gradeCountValue, which is also what SetViewTable's grade columns
  sort by (§6.4), so the number a cell shows and the number its column orders by cannot
  disagree. Zero still renders nothing: sixteen columns of "0" is noise, and the empty
  cell is the design this page has always had.
*/

import { Link } from 'react-router-dom';

import { LINK } from 'components/styles';
import { sanitizeURIPathSegment, sanitizeURISlug } from 'helpers/routing';
import { formatCount, gradeCountValue } from 'lib';

import { CardInfo } from 'types/gameInfo';

interface CardGradeViewLinkProps {
  cardInfo: CardInfo;
  grade: string;
}

function CardGradeViewLink(props: CardGradeViewLinkProps) {
  const { cardInfo, grade } = props;
  const { finalGradeCounts, number, setName, gameCode } = cardInfo;

  const count = gradeCountValue(grade, finalGradeCounts);
  if (!count) {
    return null;
  }

  return (
    <Link
      to={`/${gameCode}/${sanitizeURIPathSegment(setName)}/${sanitizeURISlug(number)}/${grade}`}
      className={LINK}
    >
      {formatCount(count)}
    </Link>
  );
}

export default CardGradeViewLink;
